import { Entry } from '../Entry'

export function Entry20230302() {
  return (
    <Entry title="March 2 2023 - v3.3.7">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13685/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
